import { z } from 'zod'

import { GetTimeSchema } from './time.ts'

export const GetDropSchema = z.object({
  date: z.coerce.date().nullish(),
  id: z.number(),
  order: z.number(),
  reference_no: z.string().nullish(),
  time: GetTimeSchema,
  type: z.enum(['collection', 'delivery']),
})
